import React from 'react';
import { roleLabel } from '../lib/permissions';

/**
 * Écran affiché quand on atteint une section fermée à son rôle — en tapant
 * l'URL, ou via un lien devenu obsolète.
 *
 * Il dit ce qui manque et à qui s'adresser, plutôt que de rediriger en
 * silence : une redirection sans explication laisse croire à une panne.
 */
const AccessDenied: React.FC<{ section?: string; role?: string }> = ({ section, role }) => (
  <div className="flex flex-1 items-center justify-center p-10">
    <div className="max-w-md text-center">
      <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-gray-100">
        <svg className="h-6 w-6 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 10-8 0v4h8z" />
        </svg>
      </div>
      <h2 className="text-lg font-semibold text-gray-900">Section réservée</h2>
      <p className="mt-2 text-sm leading-relaxed text-gray-500">
        {section ? <>La section « {section} » n'est pas accessible</> : <>Cette section n'est pas accessible</>} avec
        le rôle {roleLabel(role).toLowerCase()}. Demandez à un administrateur s'il vous faut y accéder.
      </p>
    </div>
  </div>
);

export default AccessDenied;
